import type { AddCartClickedAttributes } from '@glovo/perseus-events-perseus'
import { AddCartClicked } from '@glovo/perseus-events-perseus'
import type { PickAnalyticsEventAttributes } from '../../../../types'

export const TestEventPerseus = (_attributes: PickAnalyticsEventAttributes<'TestEventPerseus'>) => {
  const event = new AddCartClicked({ shopId: '123' } as unknown as AddCartClickedAttributes)
  return event
}
